module.exports = __webpack_public_path__ + "img/baogao.f8716327.png";